import React, {Component} from 'react';

import ideaIcon from "../../assets/images/svg/08.svg";
import collectDataIcon from "../../assets/images/svg/09.svg";
import testingIcon from "../../assets/images/svg/11.svg";
import printReportIcon from "../../assets/images/svg/10.svg";
import WOW from 'wowjs';


class HowItWorks extends Component{

    componentDidMount() {
        new WOW.WOW().init();
      }

    render(){
        return(
            <div className="how-it-work">
               <div className="container">
                 <div className="how-it-work-wrapper">
                        <div className="section-intro wow fadeInRight">
                            <h3 className="section-title">طريقة عمل الدراسة</h3>
                            <p className="section-info">تقدم الدراسة online وبشكل مباشر وفوري مما يمكن من عمله فى اى وقت واى
                                مكان بفترات متقتعه حيث ستتمكن من حفط المعطيات والرجوع لبياناتك بوقت لاحق وعند الانتهاء
                                تستطيع الحصول على ملف بصيغة PDF للحفظ والطباعة</p>
                        </div>
                    <div className="how-it-work-steps">
                            <div className="how-it-work-col">
                                <div className="how-it-work-box wow fadeInUp" data-wow-delay="0.25s">
                                    <div className="htw-content">
                                        <div className="htw-icon"><img src={ideaIcon} height="120"
                                                alt="Idea Icon"/></div>
                                        <h3 className="htw-title">تحديد الأفكار</h3>
                                        <p className="htw-detail">اختيار إسم المشروع وكتابة وصفة بشكل دقيق وكل الإحتياجات
                                            الأساسية بإستخدام العصف الذهنى والخبرات السابقة لملاك المشروع</p>
                                    </div>
                                </div>
                            </div>
                    <div className="how-it-work-col">
                            <div className="how-it-work-box wow fadeInUp" data-wow-delay="0.5s">
                                <div className="htw-content">
                                    <div className="htw-icon"><img src={collectDataIcon} height="120"
                                            alt="collect data Icon"/></div>
                                    <h3 className="htw-title">جمع المعلومات</h3>
                                    <p className="htw-detail">التعرف على السوق وحجمه ومنتجات المنافسين وتحديد الفئة
                                        المستهدفة والموردين</p>
                                </div>
                            </div>
                         <div className="how-it-work-box wow fadeInUp" data-wow-delay="0.75s">
                                <div className="htw-content">
                                    <div className="htw-icon"><img src={testingIcon} height="120"
                                            alt="testing Icon"/></div>
                                    <h3 className="htw-title">إختبار النتائج</h3>
                                    <p className="htw-detail">التأكد من ربحية المشروع و العائد على الإستثمار والتسعير الجيد
                                        المناسب للسوق وواقعية النتائج</p>
                                </div>
                            </div>
                    </div>
                           <div className="how-it-work-col">
                    <div className="how-it-work-box ml-0 wow fadeInUp" data-wow-delay="1s">
                        <div className="htw-content">
                            <div className="htw-icon"><img src={printReportIcon} height="120"
                                    alt="print report Icon"/></div>
                            <h3 className="htw-title">طباعة التقرير</h3>
                            <p className="htw-detail">بعد التأكد من النتائج وواقعيتها يمكنك طباعة التقرير التفصيلى
                                والإستفادة منه فى رحلتك الجديدة وبالتوفيق</p>
                        </div>
                    </div>
                </div>
                   </div>
                </div>
            </div>
        </div>   
        )
    }

};
export default HowItWorks;
